<app-loading *ngIf="contentReady"></app-loading>

<section
  class="bb-page create-client-page"
  [class.clients-ticket-page]="isMobile"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bb-page-shell" [class.clients-ticket-shell]="isMobile">

    <header class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ "create client" | transloco }}</span>
        <h2 class="bb-page-title">{{ "create client" | transloco }}</h2>
      </div>
    </header>

    <form class="bb-card bb-p-20 create-client-card" [formGroup]="clientForm" (ngSubmit)="saveClient()">
      <div class="bb-form-grid">

        @if(submitted && clientForm.invalid) {
        <div class="bb-form-alert bb-field-full" role="alert">
          {{ 'Review the client data before saving' | transloco }}
          @if(getMissingRequiredCount() > 0) {
          <span>
            ({{ getMissingRequiredCount() }} {{ 'required fields' | transloco }})
          </span>
          }
        </div>
        }

        <div class="bb-field">
          <label class="bb-label" for="client_name">{{ 'client name' | transloco }}</label>
          <input
            type="text"
            class="bb-input"
            id="client_name"
            formControlName="client_name"
            [placeholder]="'client name' | transloco"
            [ngClass]="{
              'is-invalid': clientForm.get('client_name')?.touched && clientForm.get('client_name')?.invalid,
              'is-valid': clientForm.get('client_name')?.touched && clientForm.get('client_name')?.valid
            }"
          />
          @if(shouldShowError('client_name')) {
          <div class="bb-field-error">{{ getErrorMessage('client_name', ('client name' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="phone_number">{{ 'phone' | transloco }}</label>
          <input
            type="tel"
            class="bb-input"
            id="phone_number"
            formControlName="phone_number"
            [placeholder]="'phone' | transloco"
            [ngClass]="{
              'is-invalid': clientForm.get('phone_number')?.touched && clientForm.get('phone_number')?.invalid,
              'is-valid': clientForm.get('phone_number')?.touched && clientForm.get('phone_number')?.valid
            }"
          />
          @if(shouldShowError('phone_number')) {
          <div class="bb-field-error">{{ getErrorMessage('phone_number', ('phone' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="another_phone">{{ 'Another Phone Number' | transloco }}</label>
          <input
            type="tel"
            class="bb-input"
            id="another_phone"
            formControlName="another_phone"
            [placeholder]="'Another Phone Number' | transloco"
            [ngClass]="{
              'is-invalid': clientForm.get('another_phone')?.touched && clientForm.get('another_phone')?.invalid,
              'is-valid': clientForm.get('another_phone')?.touched && clientForm.get('another_phone')?.valid
            }"
          />
          @if(shouldShowError('another_phone')) {
          <div class="bb-field-error">{{ getErrorMessage('another_phone', ('Another Phone Number' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="address">{{ 'address' | transloco }}</label>
          <input
            type="text"
            class="bb-input"
            id="address"
            formControlName="address"
            [placeholder]="'address' | transloco"
            [ngClass]="{
              'is-invalid': clientForm.get('address')?.touched && clientForm.get('address')?.invalid,
              'is-valid': clientForm.get('address')?.touched && clientForm.get('address')?.valid
            }"
          />
          @if(shouldShowError('address')) {
          <div class="bb-field-error">{{ getErrorMessage('address', ('address' | transloco)) }}</div>
          }
        </div>

        @if (!hideClientBalanceFields) {
        <div class="bb-field">
          <label class="bb-label" for="credit_limit">{{ 'credit_limit' | transloco }}</label>
          <input
            type="number"
            class="bb-input"
            id="credit_limit"
            formControlName="credit_limit"
            [placeholder]="'credit_limit' | transloco"
            [ngClass]="{
              'is-invalid': clientForm.get('credit_limit')?.touched && clientForm.get('credit_limit')?.invalid,
              'is-valid': clientForm.get('credit_limit')?.touched && clientForm.get('credit_limit')?.valid
            }"
          />
          @if(shouldShowError('credit_limit')) {
          <div class="bb-field-error">{{ getErrorMessage('credit_limit', ('credit_limit' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="opening_balance">{{ 'opening_balance' | transloco }}</label>
          <input
            type="number"
            class="bb-input"
            id="opening_balance"
            formControlName="opening_balance"
            [placeholder]="'opening_balance' | transloco"
            [ngClass]="{
              'is-invalid': clientForm.get('opening_balance')?.touched && clientForm.get('opening_balance')?.invalid,
              'is-valid': clientForm.get('opening_balance')?.touched && clientForm.get('opening_balance')?.valid
            }"
          />
          @if(shouldShowError('opening_balance')) {
          <div class="bb-field-error">{{ getErrorMessage('opening_balance', ('opening_balance' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field bb-field-full">
          <label class="bb-label" for="opening_balance_type">{{ 'opening_balance_type' | transloco }}</label>
          <div class="bb-select-wrap">
            <select
              class="bb-select"
              id="opening_balance_type"
              formControlName="opening_balance_type"
              [ngClass]="{
                'is-invalid': clientForm.get('opening_balance_type')?.touched && clientForm.get('opening_balance_type')?.invalid,
                'is-valid': clientForm.get('opening_balance_type')?.touched && clientForm.get('opening_balance_type')?.valid
              }"
            >
              <option value="">-- {{ 'choose' | transloco }} --</option>
              <option value="1">{{ 'credit_client' | transloco }}</option>
              <option value="2">{{ 'debit' | transloco }}</option>
            </select>
          </div>
          @if(shouldShowError('opening_balance_type')) {
          <div class="bb-field-error">{{ getErrorMessage('opening_balance_type', ('opening_balance_type' | transloco)) }}</div>
          }
        </div>
        }

        <div class="bb-field bb-field-full">
          <label class="bb-label" for="note">{{ 'note' | transloco }}</label>
          <textarea
            class="bb-input bb-textarea"
            id="note"
            formControlName="note"
            [placeholder]="'note' | transloco"
            rows="4"
            [ngClass]="{
              'is-invalid': clientForm.get('note')?.touched && clientForm.get('note')?.invalid,
              'is-valid': clientForm.get('note')?.touched && clientForm.get('note')?.valid
            }"
          ></textarea>
        </div>

        <div class="bb-field bb-field-full bb-mt-8">
          <button class="bb-btn bb-btn-primary bb-w-100" type="submit" [class.is-disabled]="clientForm.invalid">
            {{ 'Submit' | transloco }}
          </button>

          <button class="bb-btn bb-btn-secondary bb-w-100 bb-mt-12" type="button" (click)="resetClientForm()">
            {{ 'Reset' | transloco }}
          </button>
        </div>

      </div>
    </form>

  </div>
</section>
